import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Paragraph, Text, Box, SvgIcon } from 'components';
import { InfoIcon, Warning } from 'icons';

import color from 'styles/themes/wikifactory/styles/colors';
import { confToFields } from 'libs/forms';
import { ManufacturingProcessModel } from 'apps/manufacturing/app';
import { DFMIssuesAppManager } from './appManager';

interface DFMInfoProps {
  hasIssues: boolean;
  isAvailable: boolean;
  dfmIssuesAppManager: DFMIssuesAppManager; // holds the process being currently evaluated
  rfqProcess: ManufacturingProcessModel; // holds the process in the RFQ
}

export const DFMInfo = observer(
  ({
    dfmIssuesAppManager,
    hasIssues,
    isAvailable,
    rfqProcess,
  }: DFMInfoProps) => {
    const { dfmProcessFormStore, dfmProcess } = dfmIssuesAppManager;
    const isTestProcess = rfqProcess?.name !== dfmProcess?.name;

    let text = null;

    if (!isAvailable) {
      text =
        'Sorry, there is no available DFM analysis for the selected process.';
    } else if (hasIssues || isTestProcess) {
      text = `Be aware that this particular issues come from the specified
        fabrication process. Run the analysis again by choosing another
        fabrication process.`;
    }

    return (
      <Box>
        {text && (
          <Box pt={hasIssues ? 5 : 0} pb={4} sx={{ display: 'flex' }}>
            <SvgIcon icon={<InfoIcon />} size='medium' />
            <Paragraph ml={2}>{text}</Paragraph>
          </Box>
        )}

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '300px auto',
            gridGap: '20px',
          }}
        >
          <Box mb={4} sx={{}}>
            {confToFields({
              // DB query to get manufacturing processes
              formStore: dfmProcessFormStore,
              refs: {},
            })}
          </Box>
          {/* WARN the user that the currently analyzed process is not the one in the RFQ.
              We could also add a button to actually modify the RFQ with such process */}
          {isTestProcess && (
            <Box
              sx={{
                display: 'flex',
                marginTop: '18px',
                alignItems: 'center',
              }}
            >
              <SvgIcon icon={<Warning />} size='medium' />
              <Text ml={2} sx={{ color: color.wfGrey600 }}>
                This process is different than the one in this RFQ (
              </Text>
              <Text
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: color.wfGrey900,
                }}
                onClick={() => {
                  dfmIssuesAppManager.SetProcess(null);
                }}
              >
                {rfqProcess?.name}
              </Text>
              <Text sx={{ color: color.wfGrey600 }}>)</Text>
            </Box>
          )}
        </Box>
      </Box>
    );
  },
);
